import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { monthNames } from "../helpers/date";
import DateRangePicker from "../common/DateRangePicker";
import Toastify from "../common/Toastify";
import DeleteItemModal from "../../modal/DeleteItemModal";
import { GETREQUEST } from "../helpers/ServiceRequest";
import { formatInvoiceNo } from "../helpers/common";

function AllOrders() {
  let currentDate = new Date();
  var currentMonth = currentDate.getMonth() + 1;
  let currentDay = currentDate.getDate();
  if (currentDay < 10) currentDay = "0" + currentDay;
  if (currentMonth < 10) {
    currentMonth = "0" + currentMonth;
  }
  const [SearchOrderCode, setSearchOrderCode] = useState("");
  const [SearchCustomerCode, setSearchCustomerCode] = useState("");
  const [SearchCustomerName, setSearchCustomerName] = useState("");
  const [SearchPONumber, setSearchPONumber] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortBy, setSortBy] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [orders, setOrders] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [currentPage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(true);
  const [showDeleteOrderModal, setShowDeleteOrderModal] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [id, setId] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    getAllOrders();
  }, [page, size, sortColumn, sortBy, SearchOrderCode, SearchCustomerCode, SearchCustomerName, SearchPONumber, startDate, endDate]);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight - 20 + "px");
  });

  const getAllOrders = async() => {
    setLoading(true);

    let URL =
      process.env.REACT_APP_API_URL + `/get-orders?page=${page}&size=${size}`;
    let queryParams = [];

    if (SearchOrderCode) queryParams.push(`SearchOrderCode=${SearchOrderCode}`);
    if (SearchCustomerCode) queryParams.push(`SearchCustomerCode=${SearchCustomerCode}`);
    if (SearchCustomerName) queryParams.push(`SearchCustomerName=${SearchCustomerName}`);
    if (SearchPONumber) queryParams.push(`SearchPONumber=${SearchPONumber}`);
    if (startDate && endDate) queryParams.push(`startDate=${startDate}&endDate=${endDate}`);
    if (sortColumn && sortBy) queryParams.push(`sortColumn=${sortColumn}&sortBy=${sortBy}`);

    if (queryParams.length > 0) URL += `&${queryParams.join('&')}`;
    let response = await GETREQUEST(URL, user.jwtToken, false);
    if(response?.data){
      let data = response.data;
      setLoading(false);
      setOrders(data.data);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);
    }
  }
  const handleSort = (sortName) => {
    setSortColumn(sortName);
    if (sortBy == "")
      setSortBy("ASC")
    else if (sortBy == "ASC")
      setSortBy("DESC")
    else
      setSortBy("ASC")
  }

  const handleDateRange = (startDate, endDate) => {
    setStartDate(startDate ? startDate.format('YYYY/MM/DD') : null);
    setEndDate(endDate ? endDate.format('YYYY/MM/DD') : null);
  }

  const handleDelete = async () => {
    let URL =
      process.env.REACT_APP_API_URL + "/delete-order/" + id;
    setMessageType('')
    setMessage('')
    setShowDeleteOrderModal(false);
    setId(null);
    let response = await GETREQUEST(URL, user.jwtToken);
    if (response?.data) {
      let data = response.data;

      if (data.success) {
        setMessage(data.message);
        setMessageType('success');
        getAllOrders();
      } else {
        setMessage(data.message);
        setMessageType('error');
      }
    } else {
      setMessage(response?.error?.message || 'Failed to delete product !!');
      setMessageType('error');
    }
  }

  const getStartPageIndex = () => {
    return page === 0 ? 1 : page * size + 1;
  };

  const getEndPageIndex = () => {
    if (page === 0) {
      return orders.length;
    }
    const endIndex = (page + 1) * size;
    return endIndex > totalItems ? totalItems : endIndex;
  };

  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      {showDeleteOrderModal && <DeleteItemModal modal={showDeleteOrderModal} handleDelete={handleDelete} setModal={setShowDeleteOrderModal} title={"Delete Order ?"} text={"Do you want to delete this order ?"} />}
      <main className="overflow-auto">
        <section className="p-4 table-listing">
          <div className="table-elements">
            <div className="paginations d-flex align-items-center p-2">
              <p className="fs-14 text-lite mb-1 me-2">
                Showing Results{" "}
                <span className="text-dark">{totalItems == 0 ? 0 : getStartPageIndex()}</span> -{" "}
                <span className="text-dark">{getEndPageIndex()}</span> of{" "}
                <span className="text-dark">{totalItems}</span>
              </p>
              <ul className="list-inline mb-1">
                {currentPage > 0 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
                      {" "}
                      <i className={`bi bi-chevron-left text-light`}></i>{" "}
                    </a>
                  </li>
                )}
                {totalPages > currentPage + 1 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page + 1)}>
                      {" "}
                      <i className={`bi bi-chevron-right text-dark`}></i>{" "}
                    </a>
                  </li>
                )}
              </ul>
              <div style={{ marginLeft: "10px" }}>
                <select
                  className="form-select input-sm cme-10"
                  aria-label="Page size select example"
                  style={{ width: "100px" }}
                  value={size}
                  onChange={(e) => { setSize(e.target.value); setPage(0) }}
                >
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card border-bottom-0 w-100">
            <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                All Orders
              </h1>
              <div className="filter-elements d-flex align-items-center">

                <div className="custom-group flex-nowrap align-items-center">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Filter by:
                  </label>
                  <DateRangePicker onSelected={handleDateRange} />

                </div>
              </div>
            </div>
            <div className="card-body p-0 border-bottom">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      {/* <th scope="col" className="width-lg-1 width-sm-auto pe-0">
                        <input
                          type="checkbox"
                          className="form-check-input float-start cme-3"
                          id="remember"
                        />
                        <div
                          className="check-action dropdown-toggle cms-8"
                          type="button"
                          id="checkActions"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="dropdown">
                            <ul
                              className="dropdown-menu border-0 shadow-lg"
                              aria-labelledby="orders"
                              style={{ minWidth: "8rem" }}
                            >
                              <li>
                                <a
                                  className="dropdown-item fs-15 py-1 mb-1 fw-medium text-danger"
                                  href="#"
                                >
                                  <i className="icon icon-delete-drop me-2 fs-16"></i>
                                  Delete
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item fs-15 py-1 mb-1 fw-medium"
                                  href="#"
                                >
                                  <i className="icon icon-email-drop me-2 fs-14"></i>
                                  Email
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item fs-15 py-1 mb-1 fw-medium"
                                  href="#"
                                >
                                  <i className="icon icon-print-drop me-2 fs-16"></i>
                                  Print
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </th> */}
                      <th
                        scope="col"
                        className="width-lg-13 width-sm-auto  text-start "
                      >
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('OrderCode')}>Order No.</span>
                          {sortColumn == "OrderCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Order No"
                            onChange={(e) => setSearchOrderCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-8 width-sm-auto ps-3">

                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('OrderDate')}> Order Date</span>
                          {sortColumn == "OrderDate" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            style={{ visibility: "hidden" }}
                          />
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="width-lg-14 width-sm-auto"
                      >
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerCode')}>Customer Code</span>
                          {sortColumn == "CustomerCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Cust. Code"
                            onChange={(e) => setSearchCustomerCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col">
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerName')}>Customer Name</span>
                          {sortColumn == "CustomerName" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Customer Name"
                            onChange={(e) => setSearchCustomerName(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-12 width-sm-auto">

                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('PONumber')}>P.O Number</span>
                          {sortColumn == "PONumber" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by PO NO."
                            onChange={(e) => setSearchPONumber(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-5 width-sm-auto">
                        Items
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            style={{ visibility: "hidden" }}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-5 width-sm-auto">
                        Action
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            style={{ visibility: "hidden" }}
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="position-relative">
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {orders.length == 0 && (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                    {orders.map((order, index) => {
                      let date = new Date(order.OrderDate);
                      return (
                        <tr key={index}>
                          <td>{formatInvoiceNo(order.OrderID, "ORD")}</td>
                          <td className="ps-3">{date.getDate()} {monthNames[date.getMonth()]} {date.getFullYear()}</td>
                          <td>{order.tblCustomer.CustomerCode}</td>
                          <td>{order.tblCustomer.CustomerName}</td>
                          <td>{order.PurchaseOrder}</td>
                          <td className="text-center">{order?.tblOrderDetails?.length}</td>
                          <td className="d-flex gap-2">
                            <Link
                              to={`/view-edit-order/${order.OrderID}`}
                              className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                            >
                              Edit
                            </Link>
                            <button
                              onClick={() => { setShowDeleteOrderModal(true); setId(order.OrderID) }}
                              type="button"
                              className="btn btn-outline-danger btn-xs d-inline-flex align-items-center"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default AllOrders;
